import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, HostListener, Input, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CustomizerModule } from 'src/business/customizer/customizer.module';
import { NavigationModule } from 'src/core-lib/navigation/navigation.module';
import { PipeModule } from 'src/core-lib/pipes/pipe.module';
import { SourceSet } from 'src/core-lib/umbraco/umbraco-image.model';
import { VarModule } from 'src/core-lib/var/var.module';
import { MapGA4ItemsPipe } from 'src/externals/tag-manager/pipes/map-ga4-items.pipe';
import { TagManagerModule } from 'src/externals/tag-manager/tag-manager.module';
import { BreadcrumbsModule } from 'src/layout/breadcrumbs/breadcrumbs.module';
import { ImageUtil } from 'src/layout/media/image.util';
import { MediaModule } from 'src/layout/media/media.module';
import { SplashModule } from 'src/layout/splash/splash.module';
import { MarketSegment } from 'src/utils/market-segment.util';
import { StorageUtil } from 'src/utils/storage.util';
import { ProductCard } from './product-card.model';
import { IndicatorSortPipe } from '../../pipes/indicator-sort.pipe';
import { IsCustomizerPipe } from '../../pipes/is-customizer.pipe';
import { ProductCardSplashComponent } from '../product-card-splash/product-card-splash.component';

@Component({
    selector: 'app-product-card',
    templateUrl: './product-card.component.html',
    styleUrls: ['./product-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        ProductCardSplashComponent,
        IsCustomizerPipe,

        CommonModule,
        PipeModule,
        MediaModule,
        SplashModule,
        NavigationModule,
        TranslateModule,
        VarModule,
        ReactiveFormsModule,
        BreadcrumbsModule,
        CustomizerModule,
        TagManagerModule,
        IndicatorSortPipe
    ]
})
export class ProductCardComponent implements OnInit {
    @Input() product: ProductCard;
    @Input() listName: string;
    vatState: string = 'EX_VAT';
    @HostBinding('attr.grid-column-size')
    columnSize: number;
    get id() {
        return (this.product.id ?? '').split(',')[0];
    }
    image: string;
    srcset: SourceSet[];

    constructor(private _detector: ChangeDetectorRef) {}
    ngOnInit() {
        this.columnSize = this.product.columnSpan ?? 1;

        this.srcset = ImageUtil.productCardSrcset(this.product.images.find(() => true), this.columnSize);
        this.image = this.srcset[this.srcset.length - 1]?.srcset?.href;

        this.vatState = MarketSegment.isPrivateCustomer() ? 'IN_VAT' : 'EX_VAT'
        this._detector.markForCheck();

    }
}


